/* The Supplement Lab - redesign enhancements */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  // Horizontal scrollers: cards inside these reveal together when the row comes into view
  var SCROLLERS = '.slider, .sl-goals__grid, .sl-blogs__track, .sl-insta__track';
  var WAVE_SCROLLERS = '.collection .slider.product-grid, .sl-goals__grid, .sl-blogs__track, .sl-insta__track';
  var RISE_ROOM = 130; // px of temporary room under a slider while its cards rise in
  var WAVE_MAX = 10;   // px - how far cards bob while a slider is being scrolled

  /* ---------- Count-up numbers ---------- */
  function format(value, decimals, group) {
    return value.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
      useGrouping: group,
    });
  }

  function animateCount(el) {
    var raw = el.dataset.slCount;
    var target = parseFloat(raw) || 0;
    var decimals = (raw.split('.')[1] || '').length;
    var group = target >= 10000;
    var duration = 1800;
    var start = null;

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = format(target * eased, decimals, group);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters(root) {
    var els = root.querySelectorAll('[data-sl-count]:not([data-sl-done])');
    if (!els.length || reduceMotion || !hasIO) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        animateCount(entry.target);
      });
    }, { threshold: 0.4 });

    els.forEach(function (el) {
      el.dataset.slDone = '1';
      el.textContent = '0';
      observer.observe(el);
    });
  }

  /* ---------- Pop-in on scroll ---------- */
  // Also pop the product cards and headings of the theme's own collection sections
  function tagThemeElements(root) {
    if (reduceMotion) return;
    root.querySelectorAll('.collection .product-grid').forEach(function (grid) {
      Array.prototype.forEach.call(grid.children, function (item, i) {
        if (item.hasAttribute('data-sl-popped')) return;
        item.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
        item.setAttribute('data-sl-pop', '');
        item.style.setProperty('--i', i % 4);
      });
    });
    root.querySelectorAll('.collection__title').forEach(function (title) {
      if (title.hasAttribute('data-sl-popped')) return;
      title.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
      title.setAttribute('data-sl-pop', '');
    });
    document.documentElement.classList.add('sl-pop-ready');
  }

  function finishPop(el) {
    el.removeAttribute('data-sl-pop');
    el.setAttribute('data-sl-popped', '');
    el.classList.remove('is-in', 'sl-pop--inline');
  }

  function revealDelay(el) {
    return 1300 + (parseFloat(getComputedStyle(el).getPropertyValue('--i')) || 0) * 140;
  }

  function reveal(el) {
    el.classList.add('is-in');
    // Hand the element back to its normal styles (hover effects etc.) once the pop is done
    setTimeout(function () { finishPop(el); }, revealDelay(el));
  }

  // Temporarily extend a slider's box downwards (without moving anything on the page) so cards
  // rising from below are not clipped by its edge. Removed again as soon as the animation ends,
  // so swiping and the buttons under the slider are never affected.
  function openRoom(scroller) {
    var cs = getComputedStyle(scroller);
    scroller.style.paddingBottom = (parseFloat(cs.paddingBottom) + RISE_ROOM) + 'px';
    scroller.style.marginBottom = (parseFloat(cs.marginBottom) - RISE_ROOM) + 'px';
  }
  function closeRoom(scroller) {
    scroller.style.paddingBottom = '';
    scroller.style.marginBottom = '';
  }

  function initPop(root) {
    tagThemeElements(root);
    var els = root.querySelectorAll('[data-sl-pop]:not(.is-in)');
    if (!els.length) return;
    if (reduceMotion || !hasIO) { els.forEach(finishPop); return; }

    var single = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        single.unobserve(entry.target);
        reveal(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });

    var groups = new Map();
    function revealGroup(scroller) {
      var list = groups.get(scroller);
      if (!list) return;
      groups.delete(scroller);
      var longest = 0;
      openRoom(scroller);
      list.forEach(function (el) {
        longest = Math.max(longest, revealDelay(el));
        reveal(el);
      });
      setTimeout(function () { closeRoom(scroller); }, longest + 150);
    }
    var grouped = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        grouped.unobserve(entry.target);
        revealGroup(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });

    els.forEach(function (el) {
      var scroller = el.parentElement && el.parentElement.closest(SCROLLERS);
      if (scroller) {
        el.classList.add('sl-pop--inline');
        if (!groups.has(scroller)) {
          groups.set(scroller, []);
          grouped.observe(scroller);
          // Safety net: if someone swipes the row before it was revealed, show it straight away
          scroller.addEventListener('scroll', function () { revealGroup(scroller); }, { passive: true, once: true });
        }
        groups.get(scroller).push(el);
      } else {
        single.observe(el);
      }
    });
  }

  /* ---------- Cards bob gently up and down while a slider is scrolled ---------- */
  function initScrollWave(root) {
    if (reduceMotion) return;
    root.querySelectorAll(WAVE_SCROLLERS).forEach(function (scroller) {
      if (scroller.dataset.slWave) return;
      scroller.dataset.slWave = '1';

      var lastX = scroller.scrollLeft;
      var lastT = performance.now();
      var energy = 0;
      var frame = null;

      function render() {
        energy *= 0.9; // ease back down when scrolling slows or stops
        var box = scroller.getBoundingClientRect();
        var amp = Math.min(energy, WAVE_MAX);
        Array.prototype.forEach.call(scroller.children, function (card) {
          var r = card.getBoundingClientRect();
          if (r.right < box.left - 50 || r.left > box.right + 50) return; // off-screen cards: skip
          // A wave across the visible row: neighbours sit at different heights, so the row ripples
          var pos = (r.left + r.width / 2 - box.left) / Math.max(box.width, 1);
          var lift = amp * (0.5 + 0.5 * Math.sin(pos * Math.PI * 2 + performance.now() / 180));
          card.style.translate = '0 ' + (-lift).toFixed(2) + 'px';
        });
        if (energy > 0.15) {
          frame = requestAnimationFrame(render);
        } else {
          Array.prototype.forEach.call(scroller.children, function (card) { card.style.translate = ''; });
          frame = null;
        }
      }

      scroller.addEventListener('scroll', function () {
        var now = performance.now();
        var speed = Math.abs(scroller.scrollLeft - lastX) / Math.max(now - lastT, 1); // px per ms
        lastX = scroller.scrollLeft;
        lastT = now;
        energy = Math.min(WAVE_MAX, Math.max(energy, speed * 9));
        if (!frame) frame = requestAnimationFrame(render);
      }, { passive: true });
    });
  }

  /* ---------- Heading underline grows in on scroll ---------- */
  function initLines(root) {
    var els = root.querySelectorAll('.collection__title .title, [data-sl-line]');
    if (!els.length) return;
    if (reduceMotion || !hasIO) { els.forEach(function (el) { el.classList.add('sl-line-in'); }); return; }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        entry.target.classList.add('sl-line-in');
      });
    }, { threshold: 0.6 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Best-seller popups (real best sellers, no invented numbers) ---------- */
  function initTrending() {
    var box = document.getElementById('sl-trend');
    var dataEl = document.getElementById('sl-trending-data');
    if (!box || !dataEl || box.dataset.slInit) return;
    box.dataset.slInit = '1';

    var items;
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!items || !items.length) return;

    try { if (sessionStorage.getItem('sl-trend-off') === '1') return; } catch (e) {}

    var first = (parseFloat(box.dataset.first) || 8) * 1000;
    var interval = (parseFloat(box.dataset.interval) || 25) * 1000;
    var visibleFor = (parseFloat(box.dataset.visible) || 6) * 1000;
    var max = parseInt(box.dataset.max, 10) || 5;
    var shown = 0;
    var last = -1;
    var hideTimer;
    var nextTimer;

    box.style.setProperty('--sl-visible', visibleFor + 'ms');

    var link = box.querySelector('.sl-trend__link');
    var img = box.querySelector('img');
    var title = box.querySelector('.sl-trend__title');
    var cta = box.querySelector('.sl-trend__cta');
    img.removeAttribute('loading');

    // Preload the popup photos after the page has loaded so they never appear blank
    function preload() { items.forEach(function (item) { var p = new Image(); p.src = item.image; }); }
    if (document.readyState === 'complete') preload();
    else window.addEventListener('load', preload, { once: true });

    function titleCase(text) {
      return text.toLowerCase().replace(/(^|[\s&(\/-])(\S)/g, function (m, p1, p2) { return p1 + p2.toUpperCase(); });
    }

    // Always sit just above the Shopify Chat button, wherever the device/app places it
    function placeAboveChat() {
      var host = document.querySelector('shopify-chat');
      var chatButton = host && host.shadowRoot && host.shadowRoot.querySelector('button');
      var rect = chatButton && chatButton.getBoundingClientRect();
      if (rect && rect.height > 0 && rect.top > window.innerHeight * 0.5 && rect.left < window.innerWidth * 0.5) {
        box.style.bottom = Math.round(window.innerHeight - rect.top + 22) + 'px';
      } else {
        box.style.bottom = '';
      }
    }

    // Don't interrupt people while search, the menu or the cart is open
    function isBusy() {
      return !!document.querySelector('.header__search details[open], header-drawer details[open], .menu-drawer-container[open], cart-drawer.active, cart-notification .active')
        || document.body.classList.contains('overflow-hidden')
        || document.body.classList.contains('overflow-hidden-mobile')
        || document.body.classList.contains('overflow-hidden-tablet');
    }

    function scheduleNext() {
      if (shown >= max) return;
      nextTimer = setTimeout(show, interval * (0.85 + Math.random() * 0.3));
    }

    function show() {
      if (shown >= max) return;
      if (document.hidden || isBusy()) { nextTimer = setTimeout(show, 3000); return; }

      var i;
      do { i = Math.floor(Math.random() * items.length); } while (items.length > 1 && i === last);
      last = i;
      var item = items[i];

      img.src = item.image;
      img.alt = item.title;
      title.textContent = item.title;
      cta.textContent = item.category ? 'Shop ' + titleCase(item.category) + ' →' : 'View product →';
      link.href = item.url;

      placeAboveChat();
      box.hidden = false;
      // Small delay so the slide-in transition always plays
      setTimeout(function () { box.classList.add('is-visible'); }, 30);
      shown++;
      hideTimer = setTimeout(hide, visibleFor);
    }

    function hide() {
      box.classList.remove('is-visible');
      setTimeout(function () { box.hidden = true; }, 500);
      scheduleNext();
    }

    box.querySelector('.sl-trend__close').addEventListener('click', function () {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
      box.classList.remove('is-visible');
      setTimeout(function () { box.hidden = true; }, 500);
      try { sessionStorage.setItem('sl-trend-off', '1'); } catch (e) {}
    });
    box.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    box.addEventListener('mouseleave', function () {
      if (box.classList.contains('is-visible')) hideTimer = setTimeout(hide, 2500);
    });

    // Handy for previewing in the theme editor: document.getElementById('sl-trend').slShow()
    box.slShow = function () { clearTimeout(nextTimer); clearTimeout(hideTimer); shown = 0; show(); };

    nextTimer = setTimeout(show, first);
  }

  function init(root) {
    initCounters(root);
    initPop(root);
    initScrollWave(root);
    initLines(root);
    initTrending();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Re-initialise when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
